import React, { useState,useEffect} from 'react';
import PeriodSlider from '../../../../components/GlobalComponents/PeriodSlider/PeriodSlider';
import { useSelector } from 'react-redux';
import { useGetPriodById } from '../../../../components/Login/Hooks/Index';
import CircularProgress from '@mui/material/CircularProgress';
import { useGetMyKeyResultsByTenantId
 } from '../../Hooks/index';
import {Grid,Box,Typography} from '@mui/material';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import KrCart from '../../../TenantDash/LComponents/KrCart/KrCart';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const PersonKrDetails = ({personId}:any) =>{
  // const[priodId,setPriodId]=useState<string|null>(null)
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box >
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  // const onSuccesss=():void=>{
  // }
  
  // const onFailed=():void=>{
  // }

  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  // const{data:perData,isLoading:perLoading,isError:periodError,isFetched}:any=useGetPriodById(tenantId,onSuccesss,onFailed);
  // const[periodId,setPeriodId]=useState<string|null>(null);
  // const[activeIndex,setActiveIndex]=useState<any>();
    const[allKeyResult,setAllKeyresult]=useState<any[]>()
    // const[allMeeting,setAllMeeting]=useState<any[]>()
    const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
    // const [showAddObjective, setShowAddObjective] = useState<boolean>(false);

    const[showEditObjective,setShowEditObjective]=useState<Boolean|null>(false);
    const[objectiveAsynOpcState,setObjectiveAsyncOpState]=useState<any>(null);
  
  // const userTenantsData=useSelector((state:any)=>state.loign.userInfo.userTenants);
  // const initialAddObjective = (): void => {
  //   setShowAddObjective(prev => !prev)
  // }

  const setPeriodIdData = (id: string) => {
    setPeriodId(id);
  };

  const onSuccesss = (data: any) => {
    let length = data?.map((e: any) => e.isCurrent).indexOf(true);
    setPeriodId(data[length].id);
    setActiveIndex(length);
  };

  const onFailed = (): void => {};

  const {
    data: perData,
    isLoading: perLoading,
    isError: periodError,
    isFetched,
  }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [periodId, setPeriodId] = useState<string | null>(null);

  // useEffect(() => {
  //   if(perData){
  //     const active:any=perData?perData[activeIndex]:{};
  //     setPeriodId(active.id);
  //   }
  //   }, [activeIndex]);
  const{data:keyresultData,isLoading:getKeyresultLoading}
  =useGetMyKeyResultsByTenantId(periodId,tenantId,personId);
  
  // useEffect(() => {
  //   if (perData) {
  //     let length = perData?.map((e: any) => e.isCurrent).indexOf(true);
  //   setPeriodId(perData[length].id);
  //   setActiveIndex(length);
  //   }
  //   }, []);


  useEffect(() => {
    setAllKeyresult(keyresultData)
  }, [keyresultData])
  
    if (getKeyresultLoading) {
      return <Box width={'100%'} py={4} textAlign={'center'}  >
        <LoadingSpinner />
      </Box>
    }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
 
  return (
    <>
    <PeriodSlider
        setActiveIndex={setActiveIndex}
        setPriodId={setPeriodId}
        activeIndex={activeIndex}
        tenantId={tenantId}
        slideData={perData}
        dataLoading={perLoading}
      />

<Grid item xs={12}>
       <Box width={'100%'} height={'30px'} marginTop={2} >
    </Box>
    </Grid>
      <Grid container   >
      <Grid item xs={12} md={12}  >

    <Grid container>
        <Grid item xs={12} >

    <Grid item xs={12} >
    <Grid item xs={12}>
        {
       keyresultData?.length===0 && <Grid item xs={12}>
         <Box width={'100%'} textAlign={'center'} p={2}   >
           <Box>
             <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
               نتیجه کلیدی در این دوره‌‌زمانی تعریف نشده است.
             </Typography>
           </Box>
         </Box>
       </Grid>
       }

        </Grid>
     <Grid item xs={12}  >
         <Grid container spacing={1} px={1} >
        {
         keyresultData && keyresultData.map((o:any,i:number)=>{
           return <Grid  item xs={12} sm={4}  >
             <Box width={'100%'} key={i}   >
             <KrCart obj={o}   
             setShowToastMessage={setShowToastMessage}
             item={o}
             setShowEditForm={setShowEditObjective}
             setObjectiveAsyncOpState={setObjectiveAsyncOpState}
             />
           </Box>
           </Grid>
         })
       }
        </Grid> 
       </Grid>
    </Grid>

    </Grid>
    <Grid item xs={12}>
       <Box width={'100%'} height={'30px'} marginTop={2} >
    </Box>
    </Grid>
    </Grid>
</Grid>
      </Grid>
    </>
  )
}

export default PersonKrDetails